export default {
  categories: [],
  contacts: [],
  apps: [],
  translations: [],
  terms: [],
  languages: [],
  places: [],
  filters: [],
  groups: [],
}
